var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "popup-mailjet-settings",
      attrs: { visible: _vm.showModal, size: "small" },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "dialog__header" }, [
          _c(
            "div",
            { staticClass: "dialog__header--title" },
            [
              _c(
                "icon-svg",
                { attrs: { width: 56, height: 56, viewBox: "0 0 40 40" } },
                [_c("icon-mailjet")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c("span", { staticClass: "bold fs-5" }, [_vm._v("Mailjet")])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog__header--close" },
            [
              _c("CompassIconButton", {
                attrs: { icon: "close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c(
              "el-form",
              {
                ref: "mailjetForm",
                attrs: { model: _vm.mailjetConfig, rules: _vm.rules }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__("Connectez votre compte MailJet sur Sellsy.")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _vm.error
                  ? _c("div", { staticClass: "alert alert-danger mb-3" }, [
                      _vm._v(_vm._s(_vm.error))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "semibold mb-1 fs-4" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Installation")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Connectez-vous à votre compte Mailjet pour récupérer votre clé API - Mon compte puis Clé API Principale - et entrez la ci-dessous."
                          )
                        ) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Pour en savoir plus vous pouvez consulter cette "
                          )
                        ) +
                        "\n\n                        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "semibold pointer hover-primary-100",
                        attrs: {
                          target: "_blank",
                          href:
                            "https://help.sellsy.com/hc/connecter-sellsy-avec-ses-outils/mailjet"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$l10n.__("documentation")))]
                    ),
                    _vm._v(".\n                    ")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { prop: "apikey", error: _vm.errors.get("apikey") }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "semibold mb-1 gray-100",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Clé d'API")) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "Renseigner" },
                      model: {
                        value: _vm.mailjetConfig.apikey,
                        callback: function($$v) {
                          _vm.$set(_vm.mailjetConfig, "apikey", $$v)
                        },
                        expression: "mailjetConfig.apikey"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "secretkey",
                      error: _vm.errors.get("secretkey")
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "semibold mb-1 gray-100",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Clé secrète")) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "Renseigner" },
                      model: {
                        value: _vm.mailjetConfig.secretkey,
                        callback: function($$v) {
                          _vm.$set(_vm.mailjetConfig, "secretkey", $$v)
                        },
                        expression: "mailjetConfig.secretkey"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.mode === "settings"
                  ? _c(
                      "div",
                      { staticClass: "flex-column synchro-contact" },
                      [
                        _c("span", { staticClass: "semibold fs-4 mb-1" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__("Synchroniser les contacts")
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.firstConnection && !_vm.keysChanged
                          ? _c(
                              "div",
                              { staticClass: "flex-column" },
                              [
                                _c("span", { staticClass: "mb-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Vous pouvez synchroniser vos contacts Sellsy sur votre compte Mailjet."
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "ov-hidden",
                                    attrs: { prop: "contacts_list_id" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "semibold mb-1 gray-100",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__("Liste par défaut")
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("select-input", {
                                      attrs: {
                                        mode: "edit",
                                        labelColumn: "name",
                                        idColumn: "id",
                                        selectNothing: _vm.$t.__(
                                          "common.labels.none"
                                        ),
                                        appendToBody: true,
                                        options: _vm.contactsLists,
                                        placeholder: _vm.$t.__(
                                          "common.actions.select_default_list"
                                        )
                                      },
                                      model: {
                                        value:
                                          _vm.mailjetConfig.contacts_list_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mailjetConfig,
                                            "contacts_list_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mailjetConfig.contacts_list_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "mb-3" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "L’action suivante va vous permettre d’activer la synchronisation Mailjet pour les contacts de vos clients/prospects/fournisseurs en un seul clic."
                                )
                              ) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "syncroEnabled" } },
                          [
                            _c("radio-input", {
                              attrs: { mode: "edit", choices: _vm.syncChoices },
                              model: {
                                value: _vm.mailjetConfig.enabled,
                                callback: function($$v) {
                                  _vm.$set(_vm.mailjetConfig, "enabled", $$v)
                                },
                                expression: "mailjetConfig.enabled"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "ov-hidden",
                            attrs: { prop: "mcp_syncroTypeContact" }
                          },
                          [
                            _c("select-input", {
                              attrs: {
                                appendToBody: true,
                                mode: "edit",
                                options: _vm.filters
                              },
                              model: {
                                value: _vm.mailjetConfig.filter,
                                callback: function($$v) {
                                  _vm.$set(_vm.mailjetConfig, "filter", $$v)
                                },
                                expression: "mailjetConfig.filter"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                type: "secondary",
                label: _vm.$t.__("common.actions.cancel")
              },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-3",
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                loading: _vm.isFormSubmitted
              },
              on: { click: _vm.onSubmitForm }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.loading } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }